module.exports = "/resources/assets/prod/124732ec78631a9f110af5d91b62c822.svg";